// Angular
import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// Components
import {BaseComponent} from './views/theme/base/base.component';
import {AuthGuard} from './core/guards/auth.guard';
import {DroitsaccesGuard} from './core/guards/droitsacces.guard';


const routes: Routes = [
	{
		path: 'auth',
		loadChildren: () => import('app/views/modules/auth/auth.module').then(m => m.AuthModule)
	},
	{
		path: 'loading',
		canActivate: [AuthGuard],
		loadChildren: () => import('app/views/modules/loading/loading.module').then(m => m.LoadingModule)
	},

	{
		path: 'app',
		component: BaseComponent,
		canActivate: [AuthGuard, DroitsaccesGuard],
		data: {moduleName: 'espaceopal', moduleTitre: 'Tableau de bord'},
		children: [
			{
				path: 'abonnements',
				loadChildren: () => import('app/views/modules/abonnements/abonnements.module').then(m => m.AbonnementsModule)
			},
			{
				path: 'clients',
				loadChildren: () => import('app/views/modules/clients/clients.module').then(m => m.ClientsModule)
			},
			{
				path: 'distributeurs',
				loadChildren: () => import('app/views/modules/distributeurs/distributeurs.module').then(m => m.DistributeursModule)
			},
			{
				path: 'factures',
				loadChildren: () => import('app/views/modules/factures/factures.module').then(m => m.FacturesModule)
			},

			{
				path: 'modules',
				loadChildren: () => import('app/views/modules/modules/modules.module').then(m => m.ModulesModule)
			},

			{
				path: 'parametres',
				loadChildren: () => import('app/views/modules/parametres/parametres.module').then(m => m.ParametresModule)
			},

			{
				path: 'distributeurtypes',
				loadChildren: () => import('app/views/modules/distributeurtypes/distributeurtypes.module').then(m => m.DistributeurtypesModule)
			},
			{
				path: 'packages',
				loadChildren: () => import('app/views/modules/packages/packages.module').then(m => m.PackagesModule)
			},
			{
				path: 'reglements',
				loadChildren: () => import('app/views/modules/reglements/reglements.module').then(m => m.ReglementsModule)
			},
			{
				path: 'publicites',
				loadChildren: () => import('app/views/modules/publicites/publicites.module').then(m => m.PublicitesModule)
			},
			{
				path: 'marques',
				loadChildren: () => import('app/views/modules/marques/marques.module').then(m => m.MarquesModule)
			},
			{
				path: 'tableaudebord',
				loadChildren: () => import('app/views/modules/tableaudebord/tableaudebord.module').then(m => m.TableaudebordModule)
			},


			{
				path: 'tickets',
				loadChildren: () => import('app/views/modules/tickets/tickets.module').then(m => m.TicketsModule)
			},

			{
				path: 'guides',
				loadChildren: () => import('app/views/modules/guides/guides.module').then(m => m.GuidesModule)
			},



			{path: '', redirectTo: 'tableaudebord', pathMatch: 'full'},
			{path: '**', redirectTo: 'tableaudebord', pathMatch: 'full'}
		]
	},
	{
		path: 'pages',
		loadChildren: () => import('app/views/modules/pages/pages.module').then(m => m.PagesModule)
	},

	{path: '**', redirectTo: 'app', pathMatch: 'full'},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes)
	],
	exports: [RouterModule]
})
export class AppRoutingModule {
}
